<template>
  <div>
    <makuang-medical-label-record
      :consultation="consultationPrescription"
      :status="printStatus"
    />
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import MakuangMedicalLabelRecord from '@/components/TCMConsultation/Print/MakuangMedicalLabelRecord.vue';
import constant from '@/services/constant';

const { PRINT_STATUS } = constant;

export default {
  name: 'MakuangMedicalLabel',
  components: {
    MakuangMedicalLabelRecord,
  },
  computed: {
  },
  data() {
    return {
      consultationPrescription: {},
      printStatus: PRINT_STATUS.PRINTING,
    };
  },
  methods: {
    ...mapActions('print', ['getTcmConsultationPrescriptionById']),
    async preparePrescriptionInConsultationToPrint() {
      try {
        const { consultation } = this.$route.query;
        if (consultation) {
          this.consultationPrescription = await this.getTcmConsultationPrescriptionById(consultation);
          this.printStatus = PRINT_STATUS.PRINTED;
        }
      } catch (error) {
        this.consultationPrescription = {};
        this.printStatus = PRINT_STATUS.FAILED;
      }
    },
    triggerPrint() {
      setTimeout(() => {
        window.print();
      }, 2000);
    },
  },
  mounted() {
    this.preparePrescriptionInConsultationToPrint()
      .then(() => this.triggerPrint())
      .catch(() => this.triggerPrint());
  },
};
</script>
